<template>
  <div>
    <div style="margin-bottom: 10px;display: flex;flex-direction: row;align-items: center">
      <span class="text" style="font-size: 14px">托盘条码： </span>
      <span>
        <el-input
            ref="orders"
            v-model="pallet.palletNo"
            style="width: 230px"
            placeholder="请输入"/>
      </span>
      <el-button :loading="serachLoading" style="margin-left: 10px" type="primary" @click="getPalletNo">查询</el-button>
      <el-button style="margin-left: 10px" type="info" @click="clearList">重置</el-button>
      <el-button :loading="submitLoading" style="margin-left: 10px" type="primary" @click="submit">保存</el-button>
      <el-button :loading="sapWarehousingLoading" style="margin-left: 10px" type="primary" @click="sapWarehousing">SAP入库</el-button>
    </div>

    <el-table
        ref="table"
        v-loading="tableLoading"
        :data="tableData"
        style="width: 100%">
      <el-table-column type="expand">
        <template slot-scope="scope">
          <el-table
              :data="scope.row.deliveryBillPalletDetailReceivingVOS"
              style="width: 95%;margin: 0 auto">
            <el-table-column align="center" label="物料号" prop="materialNo" width="100"/>
            <el-table-column align="center" label="物料描述" prop="materialName"/>
            <el-table-column align="center" label="行号" prop="rowIndex" width="150">
              <template slot-scope="prop">
                <el-input v-model="prop.row.rowIndex"/>
              </template>
            </el-table-column>
            <el-table-column align="center" label="数量" prop="billQuantity" width="100"/>
            <el-table-column align="center" label="发货数量" prop="quantity" width="100"/>
            <el-table-column
                label="操作"
                align="center"
                class-name="vm-table_operate"
                width="110px">
              <template slot-scope="prop">
                <el-button type="primary" @click="oneDelete(scope.row.deliveryBillPalletDetailReceivingVOS,scope.$index,prop.$index)">删除</el-button>
              </template>
            </el-table-column>
          </el-table>
        </template>
      </el-table-column>
      <el-table-column prop="deliveryBillNO" align="center" label="电机发货单号"/>
      <el-table-column prop="customerContractNo" align="center" label="电气采购单号">
        <template slot-scope="scope">
          <span style="color: #2D8CF0;cursor: pointer" @click="$refs.preview.open(scope.row.customerContractNo)">{{scope.row.customerContractNo}}</span>
        </template>
      </el-table-column>
      <el-table-column prop="customerPurchaseOrderNo" align="center" label="PC号"/>
    </el-table>
    <preview ref="preview"/>
  </div>
</template>

<script>
  import constants from "@/util/constants";
  import Preview from "./Preview";
  export default {
    name: "",
    components: {Preview},
    data() {
      return {
        constants,
        tableLoading:false,
        submitLoading: false,
        serachLoading: false,
        sapWarehousingLoading:false,
        tableData:[],
        pallet:{
          palletNo:"", 
          palletId:"",
        },
      };
    },
    methods: {
      getPalletNo() {
        if(this.pallet.palletNo) {
          this.tableLoading = true;
          this.submitLoading = true;
          this.$http
            .post("basic", `purchaseReceives/getReceives/${this.pallet.palletNo}`)
            .then(resp => {
              console.log(resp);
              this.tableData = resp.deliveryBillReceivingVOS;
              this.pallet.palletNo = resp.palletNO;
              this.pallet.palletId = resp.palletId;
              this.tableLoading = false;
              this.submitLoading = false;
              this.$message.success("扫描成功");
            })
            .catch(() => {
              this.tableLoading = false;
              this.submitLoading = false;
              this.$message.error("扫描失败！");
              this.pallet.palletNo = "";
            });
        }
      },
      clearList() {
        this.pallet.palletNo = "";
        this.tableData = [];
      },

      sapWarehousing() {
        this.sapWarehousingLoading = true;
        if(this.pallet.palletNo) {
          this.$http.get("basic",`purchaseReceives/receiveMaterialsByPalletNO/${this.pallet.palletNo}`).then((res)=>{
            if(res.success) {
              this.$message.success("SAP入库成功！凭证号：" + res.data);
            }
            this.sapWarehousingLoading = false;
          }).catch(()=>{
            this.sapWarehousingLoading = false;
          });
        }
       
      },

      submit() {
        this.submitLoading = true;
        let parms={
          palletNO:this.pallet.palletNo,
          palletId:this.pallet.palletId,
          deliveryBillReceivingVOS:this.tableData,
        };
        this.$http
          .post("basic", "purchaseReceives/saveReceives", parms)
          .then(() => {
            this.$emit("save-success");
            this.$message.success("保存成功");
            this.submitLoading = false;
            this.pallet.palletNo = "";
            this.tableData = [];
          })
          .catch(() => {
            this.$message.error("保存失败");
            this.submitLoading = false;
          });
      },
      oneDelete(rowList,prentindex,index) {
        this.$confirm("确定删除吗?", "提示", {type: "warning"}).then(() => {
          rowList.splice(index, 1);
          if (rowList.length === 0) {
            this.tableData.splice(prentindex, 1);
          }
        });
      },
    },
  };
</script>

<style lang="scss">


</style>
